import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import * as rewardReducers from "../shells/Rewards/reducers";
import * as rulesReducers from "../shells/Rules/reducers";
import * as ErrorReducers from "../shells/ErrorComponent/reducers";
import * as MatchinfoReducers from "../shells/MatchInfo/reducers";
import * as LeaderboardReducers from "../shells/Leaderboard/reducers";
import * as HistoryReducers from "../shells/HistoryLeaderboard/reducers";
import * as OldLeaderboardReducers from "../shells/oldLeaderboard/reducers";
import * as EarnPointsReducers from "../shells/EarnPoints/reducers";
import * as WeeksPrizesReducers from "../shells/WeeksPrizes/reducers";
import * as helpReducers from "../shells/HelpSection/reducers";
import * as openRewardsREducers from "../shells/RewardOpening/reducers";
import * as marketingPrizesReducers from "../shells/Prizes/reducers"
import * as LoadingReducers from "../shells/LoadingComponent/reducers";


const appReducer = combineReducers({
  routing: routerReducer,
  ...rewardReducers,
  ...rulesReducers,
  ...ErrorReducers,
  ...MatchinfoReducers,
  ...LeaderboardReducers,
  ...HistoryReducers,
  ...OldLeaderboardReducers,
  ...EarnPointsReducers,
  ...WeeksPrizesReducers,
  ...helpReducers,
  ...openRewardsREducers,
  ...marketingPrizesReducers,
  ...LoadingReducers
});

const rootReducer = (state, action) => {
  if (action.type === "USER_LOGOUT") {
    // if (window.Moengage) {
    //   window.Moengage.destroy_session();
    // }
    if (window.FB) {
      window.FB.AppEvents.clearUserID();
    }
    // Raven.setUserContext();
    const { routing } = state;
    state = { routing };
  }

  return appReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/root/reducers.js